export default "__VITE_ASSET__CHCknUST__"